import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashboardLayout from "./layout/DashboardLayout.jsx";


import Dashboard from "./page/Dashboard.jsx";
import Vip from "./page/Vip.jsx";
import Member from "./page/Member.jsx";
import MemberDetail from "./page/MemberDetail.jsx";
import Heatmap from "./page/Heatmap.jsx";
import Settings from "./page/Settings.jsx";
import Customer from "./page/Customer.jsx";
import VisitLog from "./page/VisitLog.jsx";
import DeviceSettings from "./page/DeviceSettings.jsx";
import VisitProfile from "./page/VisitProfile.jsx";
import Home from "./page/Home.jsx";
import Login from "./page/Login.jsx";
import MemberAdd from "./page/MemberAdd.jsx";
import MemberEdit from "./page/MemberEdit.jsx";
import PassByDashboard from "./page/PassByDashboard.jsx";
import StaffDashboard from "./page/StaffDashboard.jsx";
import CustomerInsight from "./page/CustomerInsight.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import CustomerFlow from "./page/FlowDashboard.jsx";
import UserSettings from "./page/UserSettings.jsx";
import BranchPerformanceReport from "./page/BranchPerformanceReport.jsx";
import SuperAdmin from "./page/SuperAdmin.jsx";
import SuperAdminLayout from "./layout/SuperAdminLayout.jsx";
import SuperAdminRoute from "./components/SuperAdminRoute.jsx";
import MiniAI from "./page/MiniAI.jsx";
import SuperAdminAIUsage from "./page/SuperAdminAIUsage.jsx";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />

        <Route
          element={
            <SuperAdminRoute>
              <SuperAdminLayout />
            </SuperAdminRoute>
          }
        >
          <Route path="/superadmin" element={<SuperAdmin />} />
          <Route path="/superadmin/ai-usage" element={<SuperAdminAIUsage />} />
        </Route>
        
        <Route
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/vip" element={<Vip />} />
          <Route path="/member" element={<Member />} />
          <Route path="/member/:ulucu_id" element={<MemberDetail />} />
          <Route path="/heatmap" element={<Heatmap />} />
          <Route path="/visit-log" element={<VisitLog />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/visit-log/:userId" element={<VisitProfile />} />
          <Route path="/member/add/:ulucu_id" element={<MemberAdd />} />
          <Route path="/member/edit/:ulucu_id" element={<MemberEdit />} />
          <Route path="/pass-by-dashboard" element={<PassByDashboard />} />
          <Route path="/staff-dashboard" element={<StaffDashboard />} />
          <Route path="/customer-insight" element={<CustomerInsight />} />
          <Route path="/customer-flow" element={<CustomerFlow />} />
          <Route path="/branch-performance-report" element={<BranchPerformanceReport />} />
          <Route path="/mini-ai" element={<MiniAI />} />

          <Route path="/devices-setting" element={<DeviceSettings />} />
          <Route path="/user-setting" element={<UserSettings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
